import { formatDanishWallClock } from '@/lib/danishDateTime';

// Spor A T1.6 (DIS13-M): pure display rules for a received bookingsvar (XDIS13).

export const BOOKINGSVAR_HEADING = 'Bookingsvar';

/** DIS13-M 3.5: it must be clear that the bookingsvar is corrected. In capitals. */
export const BOOKINGSVAR_RETTET_BANNER = 'RETTET BOOKINGSVAR – ERSTATTER TIDLIGERE BOOKINGSVAR';

/**
 * DIS13-M 3.6/3.8: a date/time as sent ('YYYY-MM-DD HH:MM' or 'YYYY-MM-DD')
 * shown as dd-mm-åååå tt:mm (G3). Anything else is shown unchanged.
 */
export function bookingDateTime(value: string | null | undefined): string {
  const v = (value ?? '').trim();
  const m = v.match(/^(\d{4})-(\d{2})-(\d{2})(?:\s+(\d{2}):(\d{2}))?$/);
  if (!m) return v;
  return formatDanishWallClock(`${m[1]}${m[2]}${m[3]}`, m[4] ? `${m[4]}${m[5]}` : null);
}

/** {date, time} from the parsed document as the stored text form. */
export function dtText(dt: { date: string; time: string | null } | null | undefined): string | null {
  if (!dt || !dt.date) return null;
  return dt.time ? `${dt.date} ${dt.time}` : dt.date;
}
